<template>
  <div class="checkClass">

    <div v-for="(grupo, i) in justGrupos" :key="i">

      <label class="label-checkbox-negrito"> {{ grupo[1] == 'adm' ? 'Administrador' : grupo[1]}}</label>

    <div class = "alinhar">
      <div class="espacamento" v-for="(claim, j) in grupo[0]" :key="j">
      
        <PCheckBox :binary=true @change="verificaClaimArray()" v-model="claim[claim.claim + 'Model']"></PCheckBox>
      
        <label class="label-checkbox">{{ claim.claim }}</label>
      </div>


    </div>

    </div>


  </div>
</template>

<script>
import gclaims from './g-claims.js'
export default gclaims
</script>

<style scoped>
.espacamento{
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 3px 0px;
}
.checkClass {
  display: flex;
  justify-content: start;
  justify-items: start;
  padding-left: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.label-checkbox {
  color: #838383;
  text-align: left;
  font-family: Montserrat;
  margin-left: 6px;
}
.label-checkbox-negrito{
  color: #838383;
  text-align: left;
  font-family: Montserrat;
  margin-left: 6px;
  font-weight: bold;
  text-align: left;
    display: flex;
}

.alinhar{
  text-align: left;
  gap: 2px
}
</style>